'use client'

import { type CommonProps } from '@/utils/types'
import { type FC } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import arrow from '../../../public/icon-arrow-left.svg'
import { motion } from 'framer-motion'
import cn from '@/utils/classNames'
const menuItems = [
  { label: 'Shipbuilding and Repair', href: '#', selected: false },
  { label: 'Ports and Warehousing', href: '#', selected: false },
  { label: 'Maritime Transportation', href: '/sectors', selected: true },
  { label: 'Fishing', href: '#', selected: false },
  { label: 'Aquaculture', href: '#', selected: false },
  { label: 'Utilities', href: '#', selected: false },
  { label: 'Electric Power Generation', href: '#', selected: false },
  { label: 'Mining and Oil & Gas extraction', href: '#', selected: false },
  { label: 'Textile and Apparel', href: '#', selected: false },
  { label: 'Wholesale and Retail', href: '#', selected: false },
  { label: 'Agriculture, Food and Beverage', href: '#', selected: false },
  { label: 'Transportation and Logistics', href: '#', selected: false },
  { label: 'Tourism', href: '#', selected: false },
  { label: 'Chemicals and pharmaceuticals', href: '#', selected: false },
  { label: 'Construction', href: '#', selected: false }
] as const

/**
 * The DistinctiveFactorsSidebar component for all available domains
 * At the moment the only available sector is Maritime Transportation.
 * So it is active and statically selected
 * @returns The DistinctiveFactorsSidebar component for all available domains
 */
const DistinctiveFactorsSidebar: FC<CommonProps> = ({ className }) => {
  const classList = cn('min-w-[242px] pt-2', className)

  return (
    <motion.div
      className={classList}
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.25, ease: 'easeOut' }}
    >
      <Link className="text-xl pl-5 flex gap-4 group" aria-label="Back" href="/">
        <Image
          src={arrow}
          alt="Arrow left"
          width={16}
          height={16}
          className="group-hover:-translate-x-1 transition-transform duration-200 ease-in-out"
        />
        Back
      </Link>
      <ul className="border-t border-yale-500 pt-3 mt-3 text-sm">
        {menuItems.map((item, index) => (
          <motion.li
            key={item.label}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              duration: 0.3,
              delay: 0.1 * index,
              ease: 'easeOut'
            }}
            className={item.selected ? 'bg-marine rounded-r-lg text-yale-800 font-semibold' : 'group transition-opacity'}
          >
            <Link
              href={item.href}
              aria-label={item.label}
              className="py-2 mb-5 px-5 block group-hover:opacity-70 group-hover:cursor-not-allowed"
            >
              {item.label}
            </Link>
          </motion.li>
        ))}
      </ul>
    </motion.div>
  )
}

export default DistinctiveFactorsSidebar
